import { DownOutlined } from '@ant-design/icons'
import { Dropdown } from 'antd'
import { MenuProps } from 'antd/lib/menu'
import Button from 'app/components/UI-Elements/General/Button'
import { useActionSheet } from 'app/lib/hooks/useActionSheet'
import CapacitorService from 'app/lib/services/CapacitorService'
import * as React from 'react'

type Props = {
  onMenuClick?: MenuProps['onClick']
  options: Array<{ label: string; key: string }>
  buttonProps?: React.ComponentProps<typeof Button>
}

const { isWeb } = CapacitorService

const KDropdown: React.FC<Props> = ({
  onMenuClick,
  options,
  buttonProps: { title, onClick, ...otherButtonProps } = {}
}) => {
  const { showActions } = useActionSheet({
    title,
    options,
    onItemClick: onMenuClick
  })

  return (
    <Choose>
      <When condition={isWeb()}>
        <Dropdown
          menu={{
            items: options.map((option) => ({
              key: option.key,
              label: option.label
            })),
            onClick: onMenuClick
          }}>
          <Button type="default" onClick={onClick} {...otherButtonProps}>
            {title}
            <DownOutlined />
          </Button>
        </Dropdown>
      </When>
      <Otherwise>
        <Button type="default" onClick={showActions} {...otherButtonProps}>
          {title}
          <DownOutlined />
        </Button>
      </Otherwise>
    </Choose>
  )
}

export default KDropdown
